import {
  ApplicationConfig,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy, withPreloading, PreloadAllModules } from '@angular/router';
import { routes } from './app.routes';
import { provideLanguage } from './shared/provider/language.provider';
import { CustomTitleStrategy } from './shared/strategy/custom-title.strategy';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptor/auth.interceptor';
import { credentialsInterceptor } from './shared/interceptor/credentials.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { authProviders } from './features/auth/infrastructure/provider';
import { userProviders } from './features/user/infrastructure/provider';
import { roleProviders } from './features/role/infrastructure/provider';
import { nationalityProviders } from './features/nationality/infrastructure/provider';
import { ringProviders } from './features/ring/infrastructure/provider';
import { uploadedFileProviders } from './features/uploaded-file/infrastructure/provider';
import { guestProviders } from './features/guest/infrastructure/provider';
import { eventProviders } from './features/event/infrastructure/provider';
import { fullReportProviders } from './features/full-report/infrastructure/provider';
import { accreditationProviders } from './features/accreditation/infrastructure/provider';
import { loadRuntimeConfig } from './shared/config/runtime-config';

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      ripple: true,
      translation: {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'mi?rcoles', 'jueves', 'viernes', 's?bado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mi?', 'jue', 'vie', 's?b'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar',
      },
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([credentialsInterceptor]), withInterceptorsFromDi()),
    provideAppInitializer(() => loadRuntimeConfig()),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ConfirmationService,
    MessageService,
    ...provideLanguage,
    ...authProviders,
    ...userProviders,
    ...roleProviders,
    ...nationalityProviders,
    ...ringProviders,
    ...uploadedFileProviders,
    ...guestProviders,
    ...eventProviders,
    ...fullReportProviders,
    ...accreditationProviders,
  ],
};


